<template>
  <section class="bottom reveal">
    <div
      v-for="item in items"
      :key="item.key"
      class="feat"
      :class="item.cls"
    >
      <div class="emo"><component :is="item.icon" /></div>
      <h4>{{ trans.get(item.titleKey) }}</h4>
      <p>{{ trans.get(item.textKey) }}</p>
    </div>
  </section>
</template>

<script>
import IconHeartFilled from '../icons/IconHeartFilled.vue';
import IconChat from '../icons/IconChat.vue';
import IconBolt from '../icons/IconBolt.vue';
import IconPin from '../icons/IconPin.vue';

export default {
  name: 'BottomFeatures',
  data() {
    return {
      items: [
        {
          key: 'quiz',
          cls: 'f1',
          icon: IconHeartFilled,
          titleKey: 'landing.features.quiz_match_title',
          textKey: 'landing.features.quiz_match_text',
        },
        {
          key: 'chat',
          cls: 'f2',
          icon: IconChat,
          titleKey: 'landing.features.instant_chat_title',
          textKey: 'landing.features.instant_chat_text',
        },
        {
          key: 'joker',
          cls: 'f3',
          icon: IconBolt,
          titleKey: 'landing.features.joker_match_title',
          textKey: 'landing.features.joker_match_text',
        },
        {
          key: 'city',
          cls: 'f4',
          icon: IconPin,
          titleKey: 'landing.features.city_filter_title',
          textKey: 'landing.features.city_filter_text',
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.bottom {
  position: relative;
  z-index: 5;
  padding: 30px 56px 50px;
  max-width: 1480px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.feat {
  background: #fff;
  border-radius: 22px;
  padding: 22px;
  box-shadow: 0 10px 30px -16px rgba(26, 12, 20, 0.1);
  border: 1px solid var(--line);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.feat:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px -12px rgba(255, 59, 127, 0.2);
}

.feat .emo {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 22px;
  margin-bottom: 14px;
}

.feat.f1 .emo {
  background: linear-gradient(135deg, #ffe9e3, #ffd2c2);
  color: var(--pink);
}

.feat.f2 .emo {
  background: linear-gradient(135deg, #fff0d2, #ffd9a8);
  color: #ff7a59;
}

.feat.f3 .emo {
  background: linear-gradient(135deg, #e8dcff, #d4bfff);
  color: #8b5cf6;
}

.feat.f4 .emo {
  background: linear-gradient(135deg, #d2f5dc, #a6e8b8);
  color: #16a34a;
}

.feat h4 {
  font-family: var(--display);
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 6px;
  letter-spacing: -0.01em;
}

.feat p {
  font-size: 13px;
  line-height: 1.5;
  color: var(--ink-dim);
  margin: 0;
}

@media (max-width: 1100px) {
  .bottom {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 28px 40px;
  }
}

@media (max-width: 720px) {
  .bottom {
    grid-template-columns: 1fr;
    padding: 0 20px 32px;
    gap: 12px;
  }
  .feat {
    padding: 18px;
  }
  .feat h4 {
    font-size: 16px;
  }
  .feat p {
    font-size: 13px;
  }
}
</style>
